import { gql } from "@apollo/client";

export const ACCEPT_OR_REJECT_REFERRAL_MUTATION = gql`
  mutation AcceptOrRejectReferral($data: ReferralStatusInput) {
    acceptOrRejectReferral(data: $data)
  }
`;
